import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { Skeleton } from '~/shared/ui/components/Skeleton'
import {
  $isModuleContentLoading,
  $shouldShowGlobalEmptyState,
} from '../../model/content-loading'
import { DynamicComponents } from './components'

const emptySkin = era.skin('shared/ui/components/NoContentBlock')

DynamicPage.displayName = 'DynamicPage'
export function DynamicPage(): JSX.Element {
  const [shouldShowGlobalEmptyState, isContentLoading] = useUnit([
    $shouldShowGlobalEmptyState,
    $isModuleContentLoading,
  ])

  if (shouldShowGlobalEmptyState) {
    return (
      <ui.PageWrapper className='flex-column catalog-empty'>
        <ui.RenderSkin from={emptySkin} name='catalogEmptyPage' />
      </ui.PageWrapper>
    )
  }

  return (
    <ui.PageWrapper>
      <Skeleton pageType='main' isLoading={isContentLoading}>
        <DynamicComponents />
      </Skeleton>
    </ui.PageWrapper>
  )
}
